
import React, {useContext, useRef, useState} from "react";
import {useForm} from "react-hook-form";
import {constantes} from "../../shared/types/constantes";
import ReCAPTCHA from "react-google-recaptcha";
import {login} from '../../api/auth.service'

import {UseLoader} from "../../hooks/useLoader";
import { useNavigate } from 'react-router';

import {AppContext} from "../../context/appContext";
import {types} from "../../shared/types/types";
import { Toast } from 'primereact/toast';


export const LoginPage = () => {
    const toast = useRef(null);
    const navigate = useNavigate();

    const { dispatch} = useContext(AppContext);
    const [handleLoader] = UseLoader();
    const [captcha, setCaptcha] = useState("");
    const {register, handleSubmit, formState: {errors}} = useForm();
    const recaptchaRef = React.createRef();

    const onSubmit = async data => {

        try {
            if (data.name === undefined || data.name === '') {

                return;
            }

            if (data.password === undefined || data.password === '') {

                return;
            }

            if (captcha === undefined || captcha === '') {

                return;
            }

            const payload = {
                captcha,
                name: data.name,
                password: data.password,
            };
            handleLoader(true);
            const response = await login(payload);
            handleLoader(false);
            const resposeData = await response.data;

            if (resposeData.estado !== 200) {
                 resetCaptcha();
                toast.current?.show({severity:'warn', summary: 'Alerta', detail: resposeData.mensaje, life: 3000});
                return;
            }
            const action = {
                type: types.updateUser,
                payload: {name: resposeData.data.nombre, logged: true}
            }

            toast.current?.show({severity:'success', summary: 'Bienvenido', detail: resposeData.mensaje, life: 3000}, );


            dispatch(action)
            window.location.href = '/home';
        } catch (e) {
            console.log(e);
        }
    };

    function onChange(value) {
        setCaptcha(value);
    }

    const resetCaptcha =  () => {
         recaptchaRef.current?.reset();
    }

    return (
        <>
            <div className="container mx-auto px-4 h-full">
                <Toast ref={toast} />
                <div className="flex content-center items-center justify-center h-full">
                    <div className="w-full lg:w-4/12 px-4">
                        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">

                            <div className="flex-auto px-4 lg:px-10 py-10 pt-10">

                                <form  onSubmit={handleSubmit(onSubmit)}>
                                    <div className="relative w-full mb-3">
                                        <label
                                            className="block uppercase text-lightBlue-600 text-xs font-bold mb-2"
                                            htmlFor="grid-password"
                                        >
                                            Usuario *
                                        </label>
                                        <input
                                            {...register("name", {required: true, pattern: /^[A-Za-z0-9_]+$/i })}
                                            type="text"
                                            required
                                            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                            placeholder="Usuario"
                                        />

                                        {errors.name?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                        {errors.name?.type === 'pattern' && <span className="text-red-600 font-bold text-xs">Solo se aceptan números y letras</span>}
                                    </div>

                                    <div className="relative w-full mb-3">
                                        <label
                                            className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                            htmlFor="grid-password"
                                        >
                                            Contraseña *
                                        </label>
                                        <input
                                            {...register("password", {required: true, maxLength: 16, pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*{}-])(?=.{8,30})/i })}
                                            type="password"
                                            required
                                            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                            placeholder="Contraseña"
                                        />
                                        {errors.password?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                        {errors.password?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 16 caracteres</span>}
                                        {errors.password?.type === 'pattern' && <span className="text-red-600 font-bold text-xs">Formato incorrecto</span>}
                                    </div>
                                    <div>
                                        <ReCAPTCHA
                                            sitekey={constantes.KEY}
                                            onChange={onChange}
                                            ref={recaptchaRef}
                                        />
                                    </div>

                                    <div className="text-center mt-6">
                                        <button
                                            className="bg-lightBlue-800 text-white active:bg-lightBlue-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                                            type="submit"
                                        >
                                            Ingresar
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="flex flex-wrap mt-6 relative">
                            <div className="w-1/2">
                                <a
                                    href="#pablo"
                                    onClick={(e) => e.preventDefault()}
                                    className="text-blueGray-200"
                                >
                                    <small style={{color: "black",}}>¿Olvidaste la contraseña?</small>
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </>
    );

}
